import config from '@app/config';
import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';
import { reducers } from '@redux/reducers';
import { combineMiddleware } from './middleware';

export function makeStore() {
  return configureStore({
    reducer: reducers,
    middleware: combineMiddleware,
    devTools: config.environment !== 'PRODUCTION',
  });
}

export const store = makeStore();

export type RootStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<RootStore['getState']>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export const wrapper = createWrapper<RootStore>(makeStore);
